import { loginDesativado } from "@/router/loginDesativado";
import { RouteConfig } from "vue-router";
import { routes as privateRoutes } from "@/views/private/router";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Login",
    beforeEnter: loginDesativado,
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/Login.vue"),
  },
  {
    path: "/recuperar-senha",
    name: "RecuperarSenha",
    beforeEnter: loginDesativado,
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/views/login/RecuperarSenha.vue"
      ),
  },
  {
    path: "/definir-senha/:token",
    name: "DefinirNovaSenha",
    beforeEnter: loginDesativado,
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/views/login/DefinirNovaSenha.vue"
      ),
  },

  ...privateRoutes,
];

export default routes;
